<template>
    <div id="register-member">
        <div id="background">
            <div id="body">
                <div>
                    <div id="header">
                        <div class="header-icon"> > </div>
                        <span>会员注册</span>
                    </div>

                    <p style="margin-left: 35px; margin-right: 35px; font-size: 12px; line-height: 20px; ">
                        广州益力多乳品有限公司为感谢广大消费者对益力多的厚爱，特创立益力多 FANS
                        俱乐部，搭建与消费者互动交流的平台。会员可通过登陆网站，发表文章，玩游戏，参与活动等各种形式获取积分，并使用积分参加每月定期抽奖或兑换礼品。另外俱乐部也将定期组织会员参观工厂进行联谊活动。希望大家多多支持，把我们的俱乐部发展壮大。
                    </p>

                    <p style="color: #ed3f14">
                        *会员仅限广东省及海南省的用户
                    </p>

                    <div>
                        <span style="color: #ed3f14; font-size: 1.3rem">请阅读以下条款</span>
                    </div>

                    <div id="register-member-item">
                        <div id="first"
                             style="margin-left: 5px; margin-right: 5px; font-size: 12px; line-height: 20px; text-align: left ">
                            感谢您注册成为广州益力多网站的会员，所有注册成为本网站会员的用户，都被视为接受并遵守本服务条款。 <br>
                            1、网站会员制度<br>
                            本网站所提供的各项网络服务的运作权和所有权归广州益力多乳品有限公司所有。用户必须完全同意所有服务条款并完成注册程序，才能成为本网站的正式会员。
                        </div>
                        <div v-show="registerMemberItemCloseAndOpen" id="other"
                             style=" margin-left: 5px; margin-right: 5px; font-size: 12px; line-height: 20px; text-align: left; display: none; ">
                            2、注册资料说明<br>用户在注册成为会员时，应同意： <br>
                            （1）注册时提供详尽及准确的个人资料。选填项目请斟酌填入，加入初期可选择不填入，一旦会员获得网站提供之赠品或是进行兑换确认事宜，则必须提供选填项目完整数据以维护会员权益，若因未完整填写选填项目数据而丧失参与赠品兑换或活动，损失由会员自行负责。<br>
                            （2）会员需根据实际情况，及时更新注册资料。倘若未予实时更新导致权益受损之影响，由会员自行负责。<br>若用户提供的个人资料不准确，不真实，不符合要求，本网站保留结束用户使用本网站各项网络服务的权利。<br>
                            3、 会员帐号、密码与安全 <br>
                            （1）用户注册成功后，即成为广州益力多网站的正式会员，将得到一个有效的会员号和密码。每位会员都要对其帐号中的所有活动与事件负全部责任。如果您未保管好自己的帐号和密码而对您、广州益力多网站或第三方造成的损害或损失，您将负全部责任。
                            <br>
                            （2）每位会员只能注册一个会员号，每个家庭仅限一个会员号。会员限由本人自行使用或享有会员权利，倘自行转让、转借、出租、与人共享或以其它方式供第三人使用，数据内容发生损害，本网站不予负责。若发现同一会员使用多个会员号，本网站将删除其会员号并取消积分。<br>
                            4、会员承诺： <br>会员单独承担所有个人发布内容的全部责任。会员对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。会员若在本网站上散布和传播反动、色情或其他违反国家法律的信息，本网站的系统记录有可能作为会员违反法律的证据。
                            <br>
                            会员承诺：<br>
                            （1）在广州益力多网站的网页上发布信息或者利用广州益力多网站的服务时必须符合中国有关法规，不得在广州益力多网站的网页上制作、复制、发布、传播以下信息：<br>
                            （a） 反对宪法所确定的基本原则的；<br>
                            （b） 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
                            （c） 损害国家荣誉和利益的；<br>
                            （d） 煽动民族仇恨、民族歧视，破坏民族团结的；<br>
                            （e） 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
                            （f） 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
                            （g） 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
                            （h） 侮辱或者诽谤他人，侵害他人合法权益的；<br>
                            （i） 含有法律、行政法规禁止的其他内容的。 <br>
                            （2）不利用广州益力多网站的服务从事以下活动：<br>
                            （a） 未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br>
                            （b）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br>
                            （c） 故意制作、传播计算机病毒等破坏性程序的；<br>
                            （d） 其他危害计算机信息网络安全的行为。<br>
                            （e）未经本网站许可，在本网站发表具有广告宣传性质的内容。<br>
                            （3）不以任何方式干扰本网站的服务。 <br>
                            （4）遵守广州益力多网站的所有其他规定和程序。会员使用本网站电子公告服务，包括论坛、留言板等以交互形式为上网用户提供信息发布条件的行为，也须遵守本条的规定以及本网站专门发布的相关电子公告服务的规则，上段中描述的法律后果和法律责任同样适用于电子公告服务的用户。若会员的行为不符合以上提到的服务条款，广州益力多网站将做出独立判断立即取消用户服务帐号。<br>
                            5、会员积分制度<br>广州益力多网站施行会员积分激励制度。<br>
                            （1）积分的获取 <br>积分可从本网站提供的各项服务中获取。会员可通过登陆网站、发表文章、玩游戏、参与活动、购买产品等各种形式获取积分。本网站享有对积分管理制度进行变更的权利。
                            <br>
                            （2）积分的使用 <br>会员在本网站获取的积分可在本网站的各项服务及相应栏目中使用，但不能兑换为现金或转让给他人。对于长期不登录本网站的会员，本网站可根据具体情况删除会员号或扣除积分。
                            <br>
                            （3）其它 <br>
                            6、担保和免责声明 <br>
                            会员明确同意使用广州益力多网站所提供服务的风险由会员个人承担。本网站明确表示不提供任何类型的担保，不论是明确的或隐含的，但是对商业性的隐含担保，特定目的和不违反规定的适当担保除外。
                            <br>
                            本网站不做对所提供服务一定能满足用户要求的担保，不做服务不会受中断，也不做服务及时性、安全性、真实性、出错发生的担保。在服务中涉及到的任何商品信息、交换买卖、交易进程等属于用户的个人行为，本网站都不作担保。
                            <br>
                            会员同意，对于本网站向会员提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，本网站无需承担任何责任：<br>
                            （a）本网站向会员免费提供的各项网络服务；<br>
                            （b）本网站向会员赠送的任何产品或者服务。<br>
                            （c）对于因不可抗力或本网站不能控制的原因造成的网络服务中断或其它缺陷。<br>
                            7、有限责任
                            <br>广州益力多网站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，非法使用网络服务或用户传送的信息有所变动等。这些行为都有可能会导致本网站的形象受损，所以本网站事先提出这种损害的可能性。
                            <br>
                            8、通告 <br>
                            所有发给用户的通告都可通过重要页面的公告或电子邮件或常规的信件传送。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。 <br>
                            9、结束服务 <br>
                            广州益力多网站可随时根据实际情况中断一项或多项网络服务，本网站会提前在网站页面提示或以其他方式告知用户，而不需对任何个人或第三方负任何责任。 <br>
                            会员对条款修改有异议，或对本网站的服务不满，可以行使如下权利：<br>
                            (1) 停止使用本网站的网络服务。<br>
                            (2) 通告本网站停止对该会员的服务。<br>
                            结束会员服务后，会员使用网络服务的权利马上中止。从那时起，用户没有权利，本网站也没有义务传送任何未处理的信息或未完成的服务给会员或第三方。 <br>
                            10、网络服务内容的所有权 <br>
                            广州益力多网站定义的网络服务内容包括：文字、声音、图片、视频、图表、广告中的全部内容；电子邮件的全部内容；本网站为会员提供的其他信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在广州益力多网站授权下才能使用这些内容，而不能擅自复制、再造、或创造与内容有关的派生产品。
                            用户需保证自身为发布或提供给本网站的一切文字、图片、视频、语音及其它形式信息的作者及版权所有者。广州益力多网站有权将用户发布在本网站的文字、图片、视频、语音及其它形式信息以图书、光盘或其它形式出版。在本网站发表或提供作品视为作者同意不必支付稿酬。
                            <br>
                            11、法律<br>
                            网络服务条款要与中华人民共和国的法律解释相一致，用户和本网站一致同意服从高等法院所有管辖。如发生本网站服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户产生法律效力和影响。
                            <br>
                            12、服务条款的变更与修改 <br>
                            （1）本网站保留在必要情况下对服务条款的修改权，若服务条款发生变动，本网站将以网站公告方式通知用户。<br>
                            （2）用户如果不同意服务条款的修改，可以主动取消已经获得的网络服务；如果用户继续享用网络服务，则视为用户已经接受服务条款的修改。 <br>
                            （3）当用户使用本网站所提供的网络服务时，应接受本网站对该项服务制定的相关规则或说明，并且此规则或说明均构成本服务条款的一部分。<br>
                            13、第三方SDK目录<br>
                            为保障部分独立功能的实现，使您能够使用和享受更多的服务及功能，我们会在应用中嵌入第三方的SDK，我们将审慎评估该等SDK的使用目的。请您理解，第三方SDK的功能和服务是不断更新和发展的，其处理的数据类型等内容可能会因为功能或策略调整存在一定的变化，请以第三方公示的有关个人信息的介绍为准。<br>
                            以下是我们接入的主要的第三方服务商的信息：<br>
                            1、高德地图开放平台<br>
                            使用目的和场景：实现地址检索功能，用于为用户提供更佳的用户体验<br>
                            收集的个人信息类型：个人经纬度位置信息<br>
                            SDK提供方公司名称：高德软件有限公司<br>
                            SDK提供方隐私政策链接：https://lbs.amap.com/pages/privacy/<br>
                        </div>

                        <div class="register-icon">
                            <img v-show="registerMemberItemCloseAndOpen" id="register-member-item-open-and-close" style="width: 20px;"
                                 @click="registerItem" src="../../assets/register_member_item_close.png" alt=""/>
                            <img v-show="!registerMemberItemCloseAndOpen" id="register-member-item-open-and-open" style="width: 20px;"
                                 @click="registerItem" src="../../assets/register_member_item_open.png" alt=""/>
                        </div>
                    </div>

                    <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
                        <span class="radio" :class="{'on':item.isChecked}"></span>
                        <input v-model="radio" :value="item.value" class="input-radio" :checked='item.isChecked'  @click="check(index)" type="radio">{{item.label}}
                    </div>

                    <div id="register-member-confirm">
                        <button class="register-member-confirm-btn" @click="registerMemberConfirm">确定</button>
                    </div>
                </div>
            </div>
        </div>
        <img src="../../assets/common_member_bottom_icon.png" alt=""
             class="img-icon">
    </div>
</template>

<script>
    export default {
        name: "MemberRegister",

        data() {
            return {
                //注册条款的展开与关闭
                registerMemberItemCloseAndOpen: false,
                radio: '0',
                radios:[
                    {
                        label: '同意',
                        value:'1',
                        isChecked: false,
                    },
                    {
                        label: '不同意',
                        value:'2',
                        isChecked: false,
                    },
                ]
            }
        },

        methods: {
            registerItem() {
                this.registerMemberItemCloseAndOpen = !this.registerMemberItemCloseAndOpen;
            },

            check(index) {
                // 先取消所有选中项
                this.radios.forEach((item) => {
                    item.isChecked = false;
                });
                //再设置当前点击项选中
                this.radio = this.radios[index].value;
                // 设置值，以供传递
                this.radios[index].isChecked = true;
            },

            registerMemberConfirm() {
                if (this.radio === '1') {
                    this.$router.push({path: '/registerMemberSecond'});
                } else {
                    this.$router.go(-1)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    #register-member {
        background-color: #f8e7e9;
        height: 100%;

        #background {
            margin: 0px 10px;
            padding: 10px 0 50px;

            #body {
                width: 100%;
                height: 100%;
                border: 1px solid #eea3a3;
                border-radius: 20px;
                background: white;

                #header {
                    text-align: left;
                    margin-left: 30px;
                    margin-top: 20px;
                    margin-bottom: 20px;

                    .header-icon {
                        background: #ed3f14;
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        color: #FFFFFF;
                        font-weight: bold;
                        border-radius: 90px;
                        float: left;
                    }

                    span {
                        position: relative;
                        margin: 5px;
                        top: 3px;
                        color: #ed3f14;
                    }
                }

                #register-member-item {
                    border: 3px solid #ffa9af;
                    border-radius: 5px;
                    background-color: #fff2f2;
                    margin-left: 30px;
                    margin-right: 30px;
                    margin-top: 30px;
                }

                .radio-box{
                    display: inline-block;
                    position: relative;
                    height: 25px;
                    line-height: 25px;
                    margin-right: 5px;
                    width: 40%;
                    margin-top: 10px;
                    text-align: left;
                }
                .input-radio {
                    display: inline-block;
                    position: absolute;
                    opacity: 0;
                    width: 50%;
                    height: 25px;
                    left: 0px;
                    outline: none;
                    -webkit-appearance: none;
                }
                .radio {
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    vertical-align: middle;
                    cursor: pointer;
                    background-image: url(../../assets/radio_off.png);
                    background-repeat: no-repeat;
                    //background-position: 0 0;
                    background-size: 100% 100%;
                    margin-top: -5px;
                    margin-right: 5px;
                    //雪碧图
                }
                .on {
                    width: 20px;
                    height: 20px;
                    background-image: url(../../assets/radio_on.png);
                    background-size: 100% 100%;
                }

                #register-member-confirm {
                    margin-left: 30px;
                    margin-right: 30px;

                    .register-member-confirm-btn {
                        width: 100%;
                        height: 35px;
                        margin-top: 20px;
                        margin-bottom: 30px;
                        border: 0;
                        border-radius: 5px;
                        background-color: #ed3f14;
                        color: white;
                        font-size: 1rem;
                    }
                }
            }
        }

        .img-icon {
            width: 100%;
            height: auto;
            position: fixed;
            bottom: 0;
            left: 0;
        }
    }
</style>